<template>
    <div class="sale-contract-wrappper">
        <div class="top-wrapper">
            <div class="select-wrapper">
                <div class="select-item" @click="startTimePicker = true">
                    <span>{{ startTimeValue }}</span>
                    <i class="iconfont iconxiala"></i>
                </div>
                <p>—</p>
                <div class="select-item" @click="endTimePicker = true">
                    <span>{{ endTimeValue }}</span>
                    <i class="iconfont iconxiala"></i>
                </div>
            </div>
            <div class="statistics-head">
                <div class="month-count">
                    <span>{{ statistics.htsl || 0 }}</span>
                    <p>合同数量（个）</p>
                </div>
                <div class="year-count">
                    <span>{{ statistics.yjsxfl || 0 }}</span>
                    <p>预计销售方量（方）</p>
                </div>
            </div>
        </div>
        <div class="chart-wrapper">
            <p>按合同数量</p>
            <div id="myChart1" class="my-chart"></div>
        </div>
        <div class="bottom-wrapper">
            <p>按预计销售方量</p>
            <div id="myChart2" class="my-chart"></div>
        </div>
        <!-- 开始时间 -->
        <van-popup v-model="startTimePicker" position="bottom" :overlay="true">
            <van-datetime-picker
                v-model="startCurrentDate"
                type="year-month"
                title="选择年月"
                @confirm="startConfirmData"
                @cancel="startTimePicker = false"
            ></van-datetime-picker>
        </van-popup>
        <!-- 结束时间 -->
        <van-popup v-model="endTimePicker" position="bottom" :overlay="true">
            <van-datetime-picker
                v-model="endCurrentDate"
                type="year-month"
                title="选择年月"
                @confirm="endConfirmData"
                @cancel="endTimePicker = false"
            ></van-datetime-picker>
        </van-popup>
    </div>
</template>

<script>
import bg_blue from '../../../assets/images/home/bg_blue.png';
import bg_orange from '../../../assets/images/home/bg_orange.png';
import bg_green from '../../../assets/images/home/bg_green.png';
import { Toast } from 'vant';
export default {
    data() {
        return {
            startTimeValue: '', // 开始时间text
            endTimeValue: '', // 结束时间text
            startTimePicker: false, // 开始时间弹出层
            endTimePicker: false, // 结束时间弹出层
            startCurrentDate: new Date(new Date().getTime() - 3600 * 1000 * 24 * 120), // 开始时间默认日期
            endCurrentDate: new Date(), // 结束时间默认日期
            contractChartData: [], // 根据合同数量
            saleChartData: [], // 根据销售方量
            statistics: {},
        };
    },
    created() {
        this.startTimeValue = this.formatDate(this.startCurrentDate);
        this.endTimeValue = this.formatDate(this.endCurrentDate);
    },
    mounted() {
        this.getStatistics();
        this.getContractStatistics();
        this.getSaleStatistics();
    },
    methods: {
        getStatistics() {
            this.$axios
                .get('/interfaceApi/report/tjfx/xsht/tj?start_time='
                + this.startTimeValue + '&end_time='
                + this.endTimeValue)
                .then(res => {
                    this.statistics = res;
                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        getContractStatistics() {
            this.$axios
                .get('/interfaceApi/report/tjfx/xsht/ytjczhtsl?start_time='
                + this.startTimeValue + '&end_time='
                + this.endTimeValue)
                .then(res => {
                    this.contractChartData = res;
                    this.myChart1();
                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        getSaleStatistics() {
            this.$axios
                .get('/interfaceApi/report/tjfx/xsht/ytjczxsfl?start_time='
                + this.startTimeValue + '&end_time='
                + this.endTimeValue)
                .then(res => {
                    this.saleChartData = res;
                    this.myChart2();
                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        startConfirmData(val) {
            this.startCurrentDate = val; // 开始时间默认日期
            this.endCurrentDate = new Date(val.getTime() + 3600 * 1000 * 24 * 150);// 结束时间默认日期

            this.startTimePicker = false;
            this.startTimeValue = this.formatDate(val);
            this.endTimeValue = this.formatDate(this.endCurrentDate);
            // 头部统计字段
            this.getStatistics();
            this.getContractStatistics();
            this.getSaleStatistics();
        },
        endConfirmData(val) {
            this.startCurrentDate = new Date(val.getTime() - 3600 * 1000 * 24 * 120); // 开始时间默认日期
            this.endCurrentDate = val;// 结束时间默认日期

            this.endTimePicker = false;
            this.endTimeValue = this.formatDate(val);
            this.startTimeValue = this.formatDate(this.startCurrentDate);
            // 头部统计字段
            this.getStatistics();
            this.getContractStatistics();
            this.getSaleStatistics();
        },
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            // const d = date.getDate();
            m = m < 10 ? '0' + m : m;
            // d = d < 10 ? '0' + d : d;
            return y + '-' + m;
        },
        myChart1() {
            const myChart = this.$echarts.init(document.getElementById('myChart1'));
            const xdata = this.contractChartData.month;
            const newData = [];
            this.contractChartData.name.forEach(ele => {
                const list = this.contractChartData.list.filter(item => {
                    return item.name === ele;
                });
                newData.push({
                    name: ele,
                    list: list,
                });
            });
            newData.forEach(item => {
                const arr = [];
                item.list.forEach(jtem => {
                    arr.push(jtem.value);
                });
                item.data = arr;

            });

            const data = newData;
            const series = [];

            const itemStyle = [
                {
                    normal: {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0,
                                color: 'rgba(85,167,254,1)', //  0%  处的颜色
                            },
                            {
                                offset: 1,
                                color: 'rgba(62,121,197,1)', //  100%  处的颜色
                            },
                            ],
                            global: false, //  缺省为  false
                        },
                    },
                    emphasis: {
                        opacity: 1,
                    },
                },
                {
                    normal: {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0,
                                color: 'rgba(239,171,84,1)', //  0%  处的颜色
                            },
                            {
                                offset: 1,
                                color: 'rgba(250,140,71,1)', //  100%  处的颜色
                            },
                            ],
                            global: false, //  缺省为  false
                        },
                    },
                    emphasis: {
                        opacity: 1,
                    },
                },
                {
                    normal: {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0,
                                color: 'rgba(113,198,176,1)', //  0%  处的颜色
                            },
                            {
                                offset: 1,
                                color: 'rgba(78,164,150,1)', //  100%  处的颜色
                            },
                            ],
                            global: false, //  缺省为  false
                        },
                    },
                    emphasis: {
                        opacity: 1,
                    },
                },
            ];

            const imgarr = [
                { image: bg_blue },
                { image: bg_orange },
                { image: bg_green },
            ];

            const colorarr = ['#55A7FE', '#F98F48', '#56AC9D'];

            data.forEach((item, index) => {
                series.push({
                    name: item.name,
                    type: 'bar',
                    label: {
                        show: true,
                        position: 'top',
                        distance: 0,
                        color: colorarr[index],
                        fontWeight: 'bolder',
                        fontSize: 12,
                        formatter: '{c}',
                        align: 'center',
                        lineHeight: 20,
                        backgroundColor: imgarr[index],
                        padding: [0, 4, 4, 4],
                    },
                    itemStyle: itemStyle[index],
                    data: item.data,
                    z: 10,
                });
            });

            const hjArr = [];
            xdata.forEach(ele => {
                let num = 0;
                this.contractChartData.list.forEach(item => {

                    if (item.month === ele) {
                        num += item.value;
                    }
                });


                hjArr.push(num);
            });

            series.push({
                name: '合计',
                type: 'line',
                label: {
                    show: true,
                    position: 'top',
                    distance: 0,
                    color: '#A170D1',
                    fontWeight: 'bolder',
                    fontSize: 12,
                    formatter: '{c}',
                    align: 'center',
                },
                lineStyle: {
                    normal: {
                        color: '#A170D1', // 线条颜色
                    },
                },
                itemStyle: {
                    color: '#A170D1',
                    borderColor: '#A170D1',
                    // borderWidth: 1,
                },
                data: hjArr,
                z: 10,
            });


            const option = {
                grid: {
                    left: 30,
                    top: 50,
                    right: 0,
                    bottom: 20,
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: function (params) {
                        let str = '';
                        for (let i = 0; i < params.length; i++) {
                            if (params[i].seriesName !== '') {
                                str
                        += params[i].name
                        + ':'
                        + params[i].seriesName
                        + params[i].value
                        + '<br/>';
                            }
                        }
                        return str;
                    },
                },
                legend: {
                    left: 'right',
                    selectedMode: false,
                    top: '0',
                },
                xAxis: {
                    data: xdata,
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#979EA7',
                            fontSize: 12,
                        },
                    },
                },
                yAxis: [{
                    splitNumber: 3,
                    name: '(个)',
                    nameTextStyle: {
                        align: 'right',
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#979EA7',
                            fontSize: 12,
                        },
                    },
                    splitArea: {
                        areaStyle: {
                            color: 'rgba(255,255,255,.5)',
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#ccc',
                            width: 1,
                            type: 'dashed',
                        },
                    },
                },
                ],
                series: series,
            };
            myChart.setOption(option);
        },
        myChart2() {
            const myChart = this.$echarts.init(document.getElementById('myChart2'));
            const xdata = this.saleChartData.month;
            const newData = [];
            this.saleChartData.name.forEach(ele => {
                const list = this.saleChartData.list.filter(item => {
                    return item.name === ele;
                });
                newData.push({
                    name: ele,
                    list: list,
                });
            });
            newData.forEach(item => {
                const arr = [];
                item.list.forEach(jtem => {
                    arr.push(jtem.value);
                });
                item.data = arr;

            });

            const data = newData;
            const series = [];

            const itemStyle = [
                {
                    normal: {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0,
                                color: 'rgba(85,167,254,1)', //  0%  处的颜色
                            },
                            {
                                offset: 1,
                                color: 'rgba(62,121,197,1)', //  100%  处的颜色
                            },
                            ],
                            global: false, //  缺省为  false
                        },
                    },
                    emphasis: {
                        opacity: 1,
                    },
                },
                {
                    normal: {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0,
                                color: 'rgba(239,171,84,1)', //  0%  处的颜色
                            },
                            {
                                offset: 1,
                                color: 'rgba(250,140,71,1)', //  100%  处的颜色
                            },
                            ],
                            global: false, //  缺省为  false
                        },
                    },
                    emphasis: {
                        opacity: 1,
                    },
                },
                {
                    normal: {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0,
                                color: 'rgba(113,198,176,1)', //  0%  处的颜色
                            },
                            {
                                offset: 1,
                                color: 'rgba(78,164,150,1)', //  100%  处的颜色
                            },
                            ],
                            global: false, //  缺省为  false
                        },
                    },
                    emphasis: {
                        opacity: 1,
                    },
                },
            ];

            const imgarr = [
                { image: bg_blue },
                { image: bg_orange },
                { image: bg_green },
            ];

            const colorarr = ['#55A7FE', '#F98F48', '#56AC9D'];

            data.forEach((item, index) => {
                series.push({
                    name: item.name,
                    type: 'bar',
                    label: {
                        show: true,
                        position: 'top',
                        distance: 0,
                        color: colorarr[index],
                        fontWeight: 'bolder',
                        fontSize: 12,
                        formatter: '{c}',
                        width: 18,
                        height: 22,
                        align: 'center',
                        lineHeight: 20,
                        padding: [0, 4, 4, 4],
                        backgroundColor: imgarr[index],
                    },
                    itemStyle: itemStyle[index],
                    data: item.data,
                    // z: 10,
                });
            });

            const hjArr = [];
            xdata.forEach(ele => {
                let num = 0;
                this.saleChartData.list.forEach(item => {

                    if (item.month === ele) {
                        num += item.value;
                    }
                });


                hjArr.push(num);
            });

            series.push({
                name: '合计',
                type: 'line',
                label: {
                    show: true,
                    position: 'top',
                    distance: 0,
                    color: '#A170D1',
                    fontWeight: 'bolder',
                    fontSize: 12,
                    formatter: '{c}',
                    width: 18,
                    height: 22,
                    align: 'center',
                    lineHeight: 20,
                },
                lineStyle: {
                    normal: {
                        color: '#A170D1', // 线条颜色
                    },
                },
                itemStyle: {
                    color: '#A170D1',
                    borderColor: '#A170D1',
                    // borderWidth: 1,
                },
                data: hjArr,
                z: 10,
            });
            const option = {
                grid: {
                    left: '14%',
                    top: 50,
                    right: 10,
                    bottom: 20,
                },
                tooltip: {
                    trigger: 'axis',
                    type: 'none',
                    formatter: function (params) {
                        let str = '';
                        for (let i = 0; i < params.length; i++) {
                            if (params[i].seriesName !== '') {
                                str
                        += params[i].name
                        + ':'
                        + params[i].seriesName
                        + params[i].value
                        + '<br/>';
                            }
                        }
                        return str;
                    },
                },
                legend: {
                    left: 'right',
                    selectedMode: false,
                    top: '0',
                },
                calculable: true,
                xAxis: {
                    type: 'category',
                    data: xdata,
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#979EA7',
                            fontSize: 12,
                        },
                    },
                },
                yAxis: [{
                    type: 'value',
                    splitNumber: 4,
                    name: '(方)',
                    nameTextStyle: {
                        align: 'right',
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#979EA7',
                            fontSize: 12,
                        },
                    },
                    splitArea: {
                        areaStyle: {
                            color: 'rgba(255,255,255,.5)',
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#ccc',
                            width: 1,
                            type: 'dashed',
                        },
                    },
                },
                ],
                series: series,
            };
            myChart.setOption(option);
        },
    },
};
</script>

<style lang="stylus">
    .sale-contract-wrappper
        width 100%
        height 100%
        background #F0F0F0
        .top-wrapper
            background #ffffff
            padding 10rpx
            .select-wrapper
                height 45rpx
                box-shadow 0px 2px 8px 0px rgba(0, 0, 0, 0.16)
                border-radius 8px
                display flex
                .select-item
                    flex 1
                    text-align center
                    span
                        font-size 14rpx
                        font-weight 600
                        line-height 45rpx
                    i
                        color #979EA7
                p
                    line-height 45rpx
                    color #979EA7
                    font-weight 600
            .statistics-head
                background #ffffff
                display flex
                padding 10rpx
                margin-top 10rpx
                div
                    flex 1
                    text-align center
                    &.month-count
                        span
                            color #35AC8E
                            font-size 16rpx
                    &.year-count
                        span
                            color #FA8436
                            fonts-size 16rpx
                    p
                        font-size 10rpx
                        color #666666
                        line-height 20rpx
        .chart-wrapper
            background #ffffff
            margin-top 15rpx
            padding 10rpx
            p
                font-size 16rpx
                color #333333
                font-weight 600
                margin-top 15rpx
            .my-chart
                height 240rpx
        .bottom-wrapper
            background #ffffff
            margin-top 15rpx
            padding 10rpx
            p
                font-size 16rpx
                color #333333
                font-weight 600
            .my-chart
                height 240rpx

</style>